import { StyleSheet } from 'aphrodite/no-important';

import {
  typography,
  palettes,
  spacers,
  borderRadius,
  fonts,
} from '../../node_modules/@trainline/depot-web/lib/css/themes/trainline';

export default StyleSheet.create({
  tableRow: {
    display: 'flex',
    alignItems: 'center',
  },
  tableHeader: {
    fontFamily: typography.dp_hero_font_family,
    fontSize: typography.dp_small_font_size_m,
    backgroundColor: palettes.dp_app_backdrop_base,
    color: palettes.dp_app_text_base,
    padding: spacers.dp_s12,
    borderRadius: `${borderRadius.dp_r8} ${borderRadius.dp_r8} 0 0`,
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderBottom: `1px solid transparent`,
  },
  booking: {
    position: 'relative',
    padding: `${spacers.dp_s12} ${spacers.dp_s16}`,
    cursor: 'pointer',
    backgroundColor: palettes.dp_app_backdrop_base,
    textDecoration: 'none',
    color: palettes.dp_app_text_base,
    borderBottom: `1px solid ${palettes.dp_app_border_base}`,
    ':hover': {
      backgroundColor: palettes.dp_app_selectable_background_hover,
    },
    ':last-child': {
      borderBottom: 'none',
      borderRadius: `0 0 ${borderRadius.dp_r8} ${borderRadius.dp_r8}`,
    },
  },
  tableColumn: {
    flex: '1 0 0%',
    display: 'flex',
    fontWeight: fonts.dp_font_weight_regular,
    flexDirection: 'column',
    color: palettes.dp_app_text_subtle,
    lineHeight: '24px',
  },
  sortableColumn: {
    flexDirection: 'row',
    position: 'relative',
  },
  sortArrow: {
    width: '20px',
    height: '20px',
    position: 'relative',
    top: '2px',
  },
  productColumn: {
    flexGrow: 1.75,
    fontWeight: fonts.dp_font_weight_regular,
    flexDirection: 'column',
    paddingRight: spacers.dp_s8,
  },
  productTitle: {
    fontWeight: fonts.dp_font_weight_bold,
    flexDirection: 'row',
  },
  to: {
    overflow: 'hidden',
  },
  from: {
    overflow: 'hidden',
    paddingRight: spacers.dp_s4,
    alignItems: 'center',
    display: 'flex',
  },
  atTime: {
    fontWeight: fonts.dp_font_weight_regular,
  },
  errorMessage: {
    fontSize: typography.dp_small_font_size_m,
    color: palettes.dp_app_text_negative,
  },
  arrow: {
    flexShrink: 0,
  },
});
